var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.themeCss(_vm.themeId),staticStyle:{"width":"13px","height":"13px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }